export default __webpack_public_path__ + "static/media/zippo.0478853e.jpg";